<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">
    <mat-accordion>
        <mat-expansion-panel [expanded]="isExpanded"  class="mat-elevation-z0 navBox">
            <mat-expansion-panel-header>
                <mat-panel-title class="mt-2">
                    <h6>{{ title }}</h6>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-selection-list #navData [multiple]="false" [(ngModel)]="selOption" (ngModelChange)="onNgModelchange($event)">
                <div class="content-container" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                    <perfect-scrollbar class="scroll-container" fxFlex="auto" [config]="config" [scrollIndicators]="true" style="max-height: 200px;">
                        <div class="scrollable-content">
                            <mat-list-option *ngFor="let d of data" [value]="d" class="no-wrap">
                                <span style="font-size: 1.2rem;" class="my-1">
                                    {{d[displayPath]}}
                                </span>
                            </mat-list-option>
                        </div>
                    </perfect-scrollbar>
                </div>
            </mat-selection-list>
        </mat-expansion-panel>
    </mat-accordion>
</div>